import {
  Box,
  Button,
  Typography,
  Modal,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Info as InfoIcon, Close as CloseIcon } from "@mui/icons-material";
import TemplateInstruction from "../../assets/template/Bulk_Upload_Template_Instructions.xlsx";
import "./bulk-upload.css";
const PredefinedRulesModal = ({ open, onClose }) => {
  const [selectedDcr, setSelectedDcr] = useState("");

  const tableData = [
    [
      {
        dcr: "New HCP (OUS)",
        requiredDetails: "HCP details",
        mandatoryAttributes:
          "EntityType (Must be HCP),FirstName, LastName, ClassificationCode, CountryCode, Primary Speciality",
        templateColumn:
          "entity_type (Must be HCP),first_name, last_name, classification_code, country_code, primary_specialty",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Relation HCO Details",
        mandatoryAttributes: "Refer to Section 12 or 13",
        templateColumn: "",
        description: "",
      },
    ],
    [
      {
        dcr: "New HCP (US)",
        requiredDetails: "HCP details",
        mandatoryAttributes:
          "EntityType (Must be HCP),FirstName, LastName, ClassificationCode, CountryCode, Primary Speciality",
        templateColumn:
          "entity_type (Must be HCP),first_name, last_name, classification_code, country_code, primary_specialty",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCP Address details",
        mandatoryAttributes:
          "Address Line 1, City, Zip, State Province, Rank, CountryCode",
        templateColumn:
          "hcp_address_line_1, hcp_adrs_city, hcp_adrs_zip, hcp_adrs_state_code, hcp_adrs_rank, hcp_adrs_country",
        description: "",
      },
    ],
    [
      {
        dcr: "New HCO (US, OUS)",
        requiredDetails: "HCO details",
        mandatoryAttributes:
          "EntityType (Must be HCO),Name, ClassificationCode, CountryCode",
        templateColumn:
          "entity_type (Must be HCO),name, classification_code, country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCO Address details",
        mandatoryAttributes:
          "Address Line 1, City, Zip, State Province, Rank, CountryCode",
        templateColumn:
          "hco_adrs_line_1, hco_adrs_city, hco_adrs_zip, hco_adrs_state_code, hco_adrs_rank, hco_adrs_country",
        description: "",
      },
    ],
    [
      {
        dcr: "Edit Existing HCP (US, OUS)",
        requiredDetails: "Edit HCP Details",
        mandatoryAttributes:
          "EntityType (Must be HCP),Enterprise ID, CountryCode, Edited Attributes",
        templateColumn: "entity_type (Must be HCP),enterprise_id, country_code",
        description: "",
      },
    ],
    [
      {
        dcr: "Edit Existing HCP Address (US)",
        requiredDetails: "Edit HCP Details",
        mandatoryAttributes:
          "EntityType (Must be HCP),Enterprise ID, CountryCode, Edited Attributes if any",
        templateColumn: "entity_type (Must be HCP),enterprise_id, country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Edit HCP Address",
        mandatoryAttributes: "SourceAddressId, Edited Address Attributes",
        templateColumn: "hcp_adrs_source_adrs_id, hcp_adrs_*",
        description: "",
      },
    ],
    [
      {
        dcr: "Edit Existing HCO (US, OUS)",
        requiredDetails: "Edit HCO Details",
        mandatoryAttributes:
          "EntityType (Must be HCO),Enterprise ID, CountryCode, Edited Attributes",
        templateColumn: "entity_type (Must be HCO),enterprise_id, country_code",
        description: "",
      },
    ],
    [
      {
        dcr: "Edit Existing HCO Address (US, OUS)",
        requiredDetails: "HCO details",
        mandatoryAttributes:
          "EntityType (Must be HCO),Enterprise ID, CountryCode, Edited Attributes if any",
        templateColumn: "entity_type (Must be HCO),enterprise_id, country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCO Address details",
        mandatoryAttributes: "SourceAddressId, Edited Address Attributes",
        templateColumn: "source_address_id, hco_adrs_*",
        description: "",
      },
    ],
    [
      {
        dcr: "New Address for Existing HCO (US, OUS)",
        requiredDetails: "HCO Details",
        mandatoryAttributes:
          "EntityType (Must be HCO),Enterprise ID, CountryCode, Edited Attributes if any",
        templateColumn: "entity_type (Must be HCO),enterprise_id, country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCO Address details",
        mandatoryAttributes:
          "Address Line 1, City, Zip, State Province, Rank, CountryCode",
        templateColumn:
          "hco_adrs_line_1, hco_adrs_city, hco_adrs_zip, hco_adrs_state_code, hco_adrs_rank, hco_adrs_country",
        description: "",
      },
    ],
    [
      {
        dcr: "New Address for Existing HCP (US)",
        requiredDetails: "HCP Details",
        mandatoryAttributes:
          "EntityType (Must be HCP),Enterprise ID, CountryCode, Edited Attributes if any",
        templateColumn: "entity_type (Must be HCP),enterprise_id, country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCP Address details",
        mandatoryAttributes:
          "Address Line 1, City, Zip, State Province, Rank, CountryCode",
        templateColumn:
          "hcp_adrs_line_1, hcp_adrs_city, hcp_adrs_zip, hcp_adrs_state_code, hcp_adrs_rank, hcp_adrs_country_code",
        description: "",
      },
    ],
    [
      {
        dcr: "HCPtoHCO (US, OUS) Relationships",
        requiredDetails: "HCP details",
        mandatoryAttributes: "Refer to Section 1 or 4",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCO details",
        mandatoryAttributes: "Refer to 12 or 13",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Relationship Information",
        mandatoryAttributes:
          "IsPrimary (default No), IsParent (default Yes), RelationshipTypeCode (default PCAF)",
        templateColumn:
          "rel_hco_is_primary, rel_hco_is_parent, rel_hco_rltn_type_code",
        description: "It is always parent",
      },
    ],
    [
      {
        dcr: "HCOtoHCO (OUS)",
        requiredDetails: "HCO details",
        mandatoryAttributes: "Refer to section 3 or 6",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Relation HCO details",
        mandatoryAttributes: "Refer to section 12 or 13",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Relationship Information",
        mandatoryAttributes:
          "IsPrimary (default No), IsParent (default Yes), RelationshipTypeCode (default PCAF)",
        templateColumn:
          "rel_hco_is_primary, rel_hco_is_parent, rel_hco_rltn_type_code",
        description: "",
      },
    ],
    [
      {
        dcr: "Creating New HCO for Relationship",
        requiredDetails: "HCO details",
        mandatoryAttributes: "Name, ClassificationCode, CountryCode",
        templateColumn:
          "rel_hco_name, rel_hco_clsfctn_cd, rel_hco_country_code",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "HCO Address details",
        mandatoryAttributes:
          "Address Line 1, City, Zip, State Province, CountryCode",
        templateColumn:
          "rel_hco_adrs_line_1, rel_hco_adrs_city, rel_hco_adrs_zip, rel_hco_adrs_state_code, rel_hco_adrs_country",
        description: "",
      },
    ],
    [
      {
        dcr: "Adding Existing HCO for relationship",
        requiredDetails: "HCO details",
        mandatoryAttributes: "Enterprise ID, CountryCode",
        templateColumn: "rel_hco_enterprise_id, rel_hco_country_code",
        description: "",
      },
    ],
    [
      {
        dcr: "Email Consents",
        requiredDetails: "HCP details",
        mandatoryAttributes:
          "For New HCP refer to section (1 or 2), For Edit HCP refer to section (4)",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Email Consent details",
        mandatoryAttributes: "Email, Email Consent, Language Code (ex: en-GB)",
        templateColumn: "email, email_consent, language_code",
        description: "",
      },
    ],
    [
      {
        dcr: "Phone Consents",
        requiredDetails: "HCP details",
        mandatoryAttributes:
          "For New HCP refer to section (1 or 2), For Edit HCP refer to section (4)",
        templateColumn: "",
        description: "",
      },
      {
        dcr: "",
        requiredDetails: "Phone Consent details",
        mandatoryAttributes: "Phone, Phone Consent, Language Code (ex: en-GB)",
        templateColumn: "phone, phone_consent, language_code",
        description: "",
      },
    ],
  ];

  // Extract unique DCR values for dropdown
  const uniqueDcrs = [
    ...new Set(
      tableData
        .flat()
        .filter((row) => row.dcr && row.dcr.trim() !== "")
        .map((row) => row.dcr.trim()),
    ),
  ];

  // Filter table data based on selected DCR
  const getFilteredData = () => {
    if (!selectedDcr) {
      return tableData; // Show all data if no DCR is selected
    }

    return tableData.filter((section) => {
      // Check if any row in the section has the selected DCR
      return section.some((row) => row.dcr === selectedDcr);
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 1000 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "90vh",
          height: "80%",
          overflow: "auto",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="h6"
            style={{ width: "74%" }}
            sx={{
              color: "#D31710",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <InfoIcon />
            System Applied Validations
          </Typography>

          <Button
            className="dowbload-btn-template"
            variant="outlined"
            color="error"
            onClick={() => {
              const link = document.createElement("a");
              link.href = TemplateInstruction;
              link.download = "Bulk_Upload_Template_Instructions.xlsx";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download Instructions
          </Button>
          <IconButton onClick={onClose} sx={{ color: "#666" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body2" color="text.secondary" mb={3}>
          <b>
            {" "}
            • The following mandatory requirements are validated for each
            uploaded file.
          </b>
        </Typography>

        {/* DCR Filter Dropdown */}
        <Box sx={{ mb: 1 }}>
          <Autocomplete
            style={{ width: "200px" }}
            sx={{ minWidth: 350 }}
            size="small"
            value={selectedDcr || null}
            onChange={(event, newValue) => {
              setSelectedDcr(newValue || "");
            }}
            options={["", ...uniqueDcrs]}
            getOptionLabel={(option) => {
              if (option === "") return "Show All";
              const index = uniqueDcrs.indexOf(option);
              return `${index + 1}. ${option}`;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Filter by Scenario"
                className="select-scenario"
                placeholder="Search scenarios..."
              />
            )}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                {option === "" ? (
                  <em>Show All</em>
                ) : (
                  `${uniqueDcrs.indexOf(option) + 1}. ${option}`
                )}
              </Box>
            )}
            isOptionEqualToValue={(option, value) => option === value}
            clearOnEscape
          />
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: 400, mb: 3 }}>
          <Table stickyHeader size="small" aria-label="DCR requirements table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  S.No.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Scenario
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Required Details
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Mandatory Attributes
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Template Column
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
                let sectionCounter = 0;
                const filteredData = getFilteredData();
                return filteredData.flat().map((row, index) => {
                  if (row.dcr) {
                    sectionCounter++;
                  }
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                        "&:hover": { backgroundColor: "#f0f0f0" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#D31710",
                          fontSize: "0.875rem",
                          verticalAlign: "top",
                          textAlign: "center",
                        }}
                      >
                        {row.dcr ? sectionCounter : ""}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: row.dcr ? "bold" : "normal",
                          color: row.dcr ? "#D31710" : "inherit",
                          fontSize: "0.875rem",
                          verticalAlign: "top",
                        }}
                      >
                        {row.dcr}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "0.875rem", verticalAlign: "top" }}
                      >
                        {row.requiredDetails}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "0.875rem", verticalAlign: "top" }}
                      >
                        {row.mandatoryAttributes &&
                        row.mandatoryAttributes.includes(",") ? (
                          <Box
                            component="ul"
                            sx={{ margin: 0, paddingLeft: 2 }}
                          >
                            {row.mandatoryAttributes
                              .split(",")
                              .map((attr, idx) => (
                                <Box
                                  key={idx}
                                  component="li"
                                  sx={{ fontSize: "0.875rem", mb: 0.5 }}
                                >
                                  {attr.trim()}
                                </Box>
                              ))}
                          </Box>
                        ) : (
                          row.mandatoryAttributes
                        )}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "0.875rem",
                          fontFamily: "monospace",
                          verticalAlign: "top",
                        }}
                      >
                        {row.templateColumn &&
                        row.templateColumn.includes(",") ? (
                          <Box
                            component="ul"
                            sx={{ margin: 0, paddingLeft: 2 }}
                          >
                            {row.templateColumn.split(",").map((col, idx) => (
                              <Box
                                key={idx}
                                component="li"
                                sx={{
                                  fontSize: "0.875rem",
                                  fontFamily: "monospace",
                                  mb: 0.5,
                                }}
                              >
                                {col.trim()}
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          row.templateColumn
                        )}
                      </TableCell>
                    </TableRow>
                  );
                });
              })()}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Additional Rules and Information */}
        <Box sx={{ mt: 3, mb: 3 }}>
          {/* <Typography
            variant="h6"
            sx={{ color: "#D31710", mb: 2, fontWeight: "bold" }}
          >
            Important Notes:
          </Typography> */}
          <Box component="ul" sx={{ pl: 2, mb: 0 }}>
            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              <strong>Phone</strong> and <strong>Email</strong> consent options:
              <Box component="ul" sx={{ pl: 2, mt: 0.5, mb: 0 }}>
                <Box component="li" sx={{ mb: 0.5 }}>
                  <strong>Opt in</strong>: Add consent
                </Box>
                <Box component="li" sx={{ mb: 0.5 }}>
                  <strong>Opt out</strong>: Remove consent
                </Box>
                <Box component="li">
                  <strong>Leave blank</strong>: Keep the existing consent value
                  unchanged
                </Box>
              </Box>
            </Box>
            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              <strong>consent_acquisition_date</strong>: If no date is
              provided, the system uses today's date.
            </Box>
            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              User is allowed to upload records <strong>only</strong> for a
              country on which they have access. Any record outside the allowed
              list of countries will be marked as <strong>Invalid</strong>.
            </Box>
            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              All LoVs (List of Values/Reference Values) must have the{" "}
              <strong>Canonical Codes</strong> applicable to that Country,
              Source and Entity (HCP/HCO). In cases of any mismatch, the record
              will be marked as <strong>Invalid</strong>. Refer to the{" "}
              <i>Reference LoV</i> file available.
            </Box>
            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              An <i>Identifier</i> must always be supplied with both <i>Type</i>{" "}
              and <i>Id</i> value, where the Type is a LoV from the Reference
              LoV file. Any invalid Identifier Type will be marked as{" "}
              <strong>Invalid</strong> record.
            </Box>

            <Box component="li" sx={{ mb: 1.5, fontSize: "0.875rem" }}>
              <strong>Phone</strong> and <strong>Email</strong> columns are for
              validation purposes only, and data entered in these fields will{" "}
              <strong>not</strong> be loaded as a new consent for the HCP.
            </Box>
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button variant="contained" color="error" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PredefinedRulesModal;